export default __webpack_public_path__ + "static/media/AdditionIcon.f6d7f9ad.svg";